/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

/* eslint-disable jsdoc/check-indentation */
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* tslint:disable:typedef */


import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as Types from '../../types.generated';
export type ListESignApprovalsQueryVariables = Types.Exact<{
  UserRoles?: Types.Maybe<Types.Maybe<Types.UserRole>[]>;
  orderBy?: Types.Maybe<Types.Scalars['String']>;
  top?: Types.Maybe<Types.Scalars['Int']>;
  skip?: Types.Maybe<Types.Scalars['Int']>;
  search?: Types.Maybe<Types.Scalars['String']>;
  status?: Types.Maybe<Types.Scalars['Int']>;
  approvalType?: Types.Maybe<Types.ApprovalRequestType>;
  nextLink?: Types.Maybe<Types.Scalars['String']>;
  pathBuilder?: Types.Maybe<Types.Scalars['PathBuilder']>;
}>;


export type ListESignApprovalsQuery = (
  { __typename?: 'QueryDefinition' }
  & { ListESignApprovals?: Types.Maybe<(
    { __typename?: 'ListESignApprovals' }
    & Pick<Types.ListESignApprovals, 'nextLink'>
    & { signingRequests?: Types.Maybe<Types.Maybe<(
      { __typename?: 'ESignApproval' }
      & Pick<Types.ESignApproval, 'id' | 'title' | 'message' | 'status' | 'source' | 'expirationDateTime' | 'creationDateTime' | 'url'>
      & { recipients?: Types.Maybe<Types.Maybe<(
        { __typename?: 'Recipient' }
        & Pick<Types.Recipient, 'id' | 'userId' | 'fullName' | 'email' | 'role' | 'signingOrder' | 'roleStatus'>
      )>[]>; sender?: Types.Maybe<(
        { __typename?: 'Sender' }
        & Pick<Types.Sender, 'id' | 'userId' | 'fullName' | 'email'>
      )>; history?: Types.Maybe<Types.Maybe<(
        { __typename?: 'History' }
        & Pick<Types.History, 'status' | 'date' | 'comments'>
        & { author?: Types.Maybe<(
          { __typename?: 'Recipient' }
          & Pick<Types.Recipient, 'id' | 'fullName' | 'email' | 'role' | 'signingOrder' | 'roleStatus'>
        )>; }
      )>[]>; }
    )>[]>; }
  )>; }
);


export const ListESignApprovalsDocument = gql`
    query ListESignApprovals($UserRoles: [UserRole], $orderBy: String, $top: Int, $skip: Int, $search: String, $status: Int, $approvalType: ApprovalRequestType, $nextLink: String, $pathBuilder: PathBuilder) {
  ListESignApprovals(UserRoles: $UserRoles, orderBy: $orderBy, skip: $skip, top: $top, search: $search, status: $status, approvalType: $approvalType, nextLink: $nextLink, pathBuilder: $pathBuilder) @rest(type: "ListESignApprovals", method: "GET", endpoint: EsignGateway, pathBuilder: $pathBuilder) {
    signingRequests {
      id
      title
      message
      recipients {
        id
        userId
        fullName
        email
        role
        signingOrder
        roleStatus
      }
      sender {
        id
        userId
        fullName
        email
      }
      status
      history {
        author {
          id
          fullName
          email
          role
          signingOrder
          roleStatus
        }
        status
        date
        comments
      }
      source
      expirationDateTime
      creationDateTime
      url
    }
    nextLink
  }
}
    `;

/**
 * __useListESignApprovalsQuery__
 *
 * To run a query within a React component, call `useListESignApprovalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListESignApprovalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListESignApprovalsQuery({
 *   variables: {
 *      UserRoles: // value for 'UserRoles'
 *      orderBy: // value for 'orderBy'
 *      top: // value for 'top'
 *      skip: // value for 'skip'
 *      search: // value for 'search'
 *      status: // value for 'status'
 *      approvalType: // value for 'approvalType'
 *      nextLink: // value for 'nextLink'
 *      pathBuilder: // value for 'pathBuilder'
 *   },
 * });
 */
export function useListESignApprovalsQuery(baseOptions?: Apollo.QueryHookOptions<ListESignApprovalsQuery, ListESignApprovalsQueryVariables>) {
        return Apollo.useQuery<ListESignApprovalsQuery, ListESignApprovalsQueryVariables>(ListESignApprovalsDocument, baseOptions);
      }
export function useListESignApprovalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListESignApprovalsQuery, ListESignApprovalsQueryVariables>) {
          return Apollo.useLazyQuery<ListESignApprovalsQuery, ListESignApprovalsQueryVariables>(ListESignApprovalsDocument, baseOptions);
        }
export type ListESignApprovalsQueryHookResult = ReturnType<typeof useListESignApprovalsQuery>;
export type ListESignApprovalsLazyQueryHookResult = ReturnType<typeof useListESignApprovalsLazyQuery>;
export type ListESignApprovalsQueryResult = Apollo.QueryResult<ListESignApprovalsQuery, ListESignApprovalsQueryVariables>;